<template>
  <div style="background-color: #F7F7F7;">
    <div class="container case-content-container" style="height:100%">
      <div class="case-content-box flex">
        <div
          class="each-case-content "
          v-for="item in caseContentData"
          :key="item.id"
        >
          <img
            class="each-case-content-img"
            v-lazy="IPCONFIG + item.articleThumbnail"
            alt=""
          />
          <div class="each-case-content-box">
            <div class="each-case-content-title chaochu">
              {{ item.articleTitle }}
            </div>
            <div class="each-case-content-name black-6 chaochu">
              {{ item.articleSummary }}
            </div>
            <div
              class="carousel-content-details flex-center"
              @click="goCaseDetails(item.articleId)"
            >
              {{ $t("localization.solveProjectFong15") }}
            </div>
          </div>
        </div>
      </div>
      <div class="pagina flex-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-size="size"
          layout="total, prev, pager, next"
          :pager-count="count"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassify, getClassifyDetails } from "@/api/index.js";
export default {
  data() {
    return {
      caseSelectData: [],
      caseSelectIndex: 0,
      page: 1,
      size: 8,
      total: 0,
      count: 5,
      caseContentData: [],
      voice: "",
      queryId: ""
    };
  },
  mounted() {
    this.voice =
      localStorage.getItem("DefaultLanguage") == "en-US" ? "en" : "zh";
    getClassify({ classifyType: "0", language: this.voice }).then(res => {
      if (res.code == 0) {
        if (res.data.length > 0) {
          if (this.voice == "zh") {
            this.caseSelectData = [
              { classifyName: "全部", classifyId: "", outLink: "AllCase" }
            ];
          } else {
            this.caseSelectData = [
              { classifyName: "All", classifyId: "", outLink: "AllCase" }
            ];
          }
          this.caseSelectData[0].classifyId = res.data[0].classifyId;
          this.queryId = this.caseSelectData[0].classifyId;
          res.data[0].children.forEach(item => {
            this.caseSelectData.push(item);
          });
          let path = this.$route.path;
          let arr = path.split("/"); // 通过'/'截取路由，返回数组
          this.caseSelectData.forEach((item,index )=> {
            if (item.outLink == arr[2]) {
              this.queryId = item.classifyId;
              this.$addStorageEvent("caseChildren", index - 1);
            }
          });
          this.getClassifyDetailsData({
            classifyId: this.queryId,
            pageNum: this.page,
            pageSize: this.size
          });
        }
      }
    });
    window.addEventListener("setItem", e => {
      if (e.key === "DefaultLanguage") {
        if (e.newValue == "en-US") {
          this.voice = "en";
        } else {
          this.voice = "zh";
        }
        getClassify({ classifyType: "0", language: this.voice }).then(res => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              if (this.voice == "zh") {
                this.caseSelectData = [
                  { classifyName: "全部", classifyId: "", outLink: "AllCase" }
                ];
              } else {
                this.caseSelectData = [
                  { classifyName: "All", classifyId: "", outLink: "AllCase" }
                ];
              }
              this.caseSelectData[0].classifyId = res.data[0].classifyId;
              this.queryId = this.caseSelectData[0].classifyId;
              res.data[0].children.forEach(item => {
                this.caseSelectData.push(item);
              });

              this.getClassifyDetailsData({
                classifyId: this.queryId,
                pageNum: this.page,
                pageSize: this.size
              });
            }
          }
        });
        this.caseSelectIndex = 0;
      }
      if (e.key == "caseChildren") {
        this.caseSelectIndex = Number(e.newValue) + 1;
      }
    });
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getClassifyDetailsData({
        classifyId: this.queryId,
        pageNum: this.page,
        pageSize: this.size
      });
    },
    goCaseDetails(id) {
      this.$router.push({ path: "/caseDetails", query: { id } });
    },
    getClassifyDetailsData(data) {
      getClassifyDetails(data).then(res => {
        if (res.code == 0) {
          this.caseContentData = res.rows;
          this.total = res.total;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/case-box.vue